import LabDashboard from "@/pages/chemistries/lab-dashboard";
import ChemistriesReport from "@/pages/chemistries/report";
import Chemistries from "@/pages/lab/chemistries";
import LabTensileRequirements from "@/pages/lab/tensile-requirements";
import LabTestsBySection from "@/pages/lab/tests-by-section";
import { PermissionRoute } from "./PermissionRoute";

export const routeLabChemistries = "/lab/chemistries";
export const routeChemistriesReport = "/chemistries/report";
export const routeLabDashboard = "/lab/dashboard";
export const routeLabTestsBySection = "/lab/tests-by-section";
export const routeLabTensileRequirements = "/lab/tensile-requirements";

export const labRoutes = [
	{
		path: routeLabChemistries,
		element: <Chemistries />,
		permission: "ui.navbar.lab.chemistries",
	},
	{
		path: `${routeChemistriesReport}`,
		element: <ChemistriesReport />,
		permission: "ui.navbar.lab.chemistries.report",
	},
	{
		path: `${routeLabDashboard}`,
		element: <LabDashboard />,
		permission: "ui.navbar.lab.dashboard",
	},
	{
		path: routeLabTestsBySection,
		element: (
			<PermissionRoute permission={"ui.navbar.lab.tests.by.section"}>
				<LabTestsBySection />
			</PermissionRoute>
		),
		permission: "ui.navbar.lab.tests.by.section",
	},
	{
		path: routeLabTensileRequirements,
		element: (
			<PermissionRoute permission={"ui.navbar.lab.tensile.requirements"}>
				<LabTensileRequirements />
			</PermissionRoute>
		),
		permission: "ui.navbar.lab.tensile.requirements",
	},
];
